import PropTypes from 'prop-types';
import { createContext, useCallback, useState } from 'react';

export const NegModalContext = createContext();

export const NegModalContextProvider = ({ children }) => {
  const [isInsertOrderModalOpened, setIsInsertOrderModalOpened] =
    useState(false);
  const [defaultOperationType, setDefaultOperationType] = useState(0);

  const openInsertOrderModal = useCallback((operationType) => {
    setIsInsertOrderModalOpened(true);
    setDefaultOperationType(operationType);
  }, []);

  return (
    <NegModalContext.Provider
      value={{
        isInsertOrderModalOpened,
        setIsInsertOrderModalOpened,
        defaultOperationType,
        openInsertOrderModal,
      }}
    >
      {children}
    </NegModalContext.Provider>
  );
};

NegModalContextProvider.propTypes = {
  children: PropTypes.element,
};
